/** Meridian. — pure-typography wordmark, no icon. Sentence case, set in the
 *  app's own Plus Jakarta Sans at semibold with tightened tracking so it
 *  reads as a mark rather than a run of body text; the accent-blue full stop
 *  is the brand's one flourish. Default text colour is ``text-slate-100``,
 *  which the light-theme override layer flips to near-black so the wordmark
 *  stays legible on a white sidebar; surfaces that are dark in *both* themes
 *  (the sign-in page) pass ``colorClass="text-white"``. */

export function BrandLockup({
  sizeClass = "text-[19px]",
  colorClass = "text-slate-100",
}: { sizeClass?: string; colorClass?: string } = {}) {
  return (
    <div className="inline-flex items-baseline select-none leading-none">
      <span className={`${sizeClass} ${colorClass} font-semibold tracking-[-0.03em]`}>
        Meridian
      </span>
      <span className={`${sizeClass} font-semibold tracking-[-0.03em] text-accent-400`}>
        .
      </span>
    </div>
  );
}
